import React from 'react';
import { ShieldIcon, HeartIcon, UserIcon } from 'lucide-react';
export function ProblemStatement() {
  const stats = [{
    icon: <ShieldIcon className="h-6 w-6 text-emerald-500" data-id="element-188" />,
    value: '1 in 4',
    label: 'Young Africans struggle with mental health issues'
  }, {
    icon: <HeartIcon className="h-6 w-6 text-emerald-500" data-id="element-189" />,
    value: '80%',
    label: "Don't seek help due to stigma and accessibility"
  }, {
    icon: <UserIcon className="h-6 w-6 text-emerald-500" data-id="element-190" />,
    value: '10:1',
    label: 'Patient to therapist ratio in many African countries'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-191">
      <div className="container mx-auto px-4" data-id="element-192">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-194">
            Mental health shouldn't be a silent struggle
          </h2>
          <p className="text-lg text-gray-700" data-id="element-195">
            Too many young Africans face mental health challenges alone, caught
            between cultural expectations, economic pressures, and limited
            access to relevant support.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-196">
          {stats.map((stat, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-197">
              <div className="bg-emerald-50 p-3 rounded-full mb-4" data-id="element-198">
                {stat.icon}
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-199">
                {stat.value}
              </h3>
              <p className="text-gray-700" data-id="element-200">{stat.label}</p>
            </div>)}
        </div>
        <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-201">
          <div className="md:flex" data-id="element-202">
            <div className="md:w-1/2" data-id="element-203">
              <img src="https://images.unsplash.com/photo-1531206715517-5c0ba140b2b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Young African professional looking stressed" className="h-full w-full object-cover" data-id="element-204" />
            </div>
            <div className="p-8 md:w-1/2" data-id="element-205">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-206">
                Current solutions aren't working for us
              </h3>
              <div className="space-y-4" data-id="element-207">
                <div className="flex items-start" data-id="element-208">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-209">
                    <span className="text-red-500 text-sm" data-id="element-210">✕</span>
                  </div>
                  <p className="text-gray-700" data-id="element-211">
                    <strong data-id="element-212">Cultural disconnect:</strong> "They don't understand
                    our family dynamics and pressures"
                  </p>
                </div>
                <div className="flex items-start" data-id="element-213">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-214">
                    <span className="text-red-500 text-sm" data-id="element-215">✕</span>
                  </div>
                  <p className="text-gray-700" data-id="element-216">
                    <strong data-id="element-217">Cost barriers:</strong> "I can't afford 3000 KES per
                    therapy session"
                  </p>
                </div>
                <div className="flex items-start" data-id="element-218">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-219">
                    <span className="text-red-500 text-sm" data-id="element-220">✕</span>
                  </div>
                  <p className="text-gray-700" data-id="element-221">
                    <strong data-id="element-222">Stigma:</strong> "People will think I'm crazy if
                    they find out"
                  </p>
                </div>
                <div className="flex items-start" data-id="element-223">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-224">
                    <span className="text-red-500 text-sm" data-id="element-225">✕</span>
                  </div>
                  <p className="text-gray-700" data-id="element-226">
                    <strong data-id="element-227">Accessibility:</strong> "Services aren't available
                    when and where I need them"
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}